import {Loading, Message} from "element-ui";
import {getErrorMessage} from "./ResultUtil";
import {getUuid, getUUID} from "./UuidUtil.js";
import {download} from "./DownloadUtil.js";

let timeout = 10 * 1000;
let loading;

function loadingClose() {
    if (loading) {
        loading.close();
        loading = null;
    }
}

function showLoading(isShow = true) {
    if (isShow) {
        loading = Loading.service({
            text: "Loading...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
        });
        setTimeout(() => {
            if (loading) {
                loading.close();
                loading = null;
                errorMessage("请求超时");
            }
        }, timeout);
    } else {
        loadingClose();
    }
}

function message(msg, type) {
    Message({
        message: msg,
        type: type,
        showClose: true,
        dangerouslyUseHTMLString: true,
        duration: 3000
    });
}

function errorMessage(msg) {
    message(msg, "error");
}

function showErrorMessage(message, error) {
    if (error && error.code !== 99 && error.message) {
        message = error.message;
    }
    errorMessage(message);
}

export {
    getErrorMessage,
    getUuid,
    getUUID,
    showLoading,
    loadingClose,
    errorMessage,
    showErrorMessage,
    download
};
